import { Subject } from 'rxjs';

const refreshNotesGrid = new Subject<boolean>();

const SubjectProfileService = {
    refreshNotesGrid: () => {
        refreshNotesGrid.next(true);
    },
    onRefreshNotesGrid() {
        return refreshNotesGrid.asObservable();
    },
};

export default SubjectProfileService;
